const Record = require('admin/core/Record')
const BillableRecord = require('admin/data/company/BillableRecord')
const CompanyStore = require('admin/data/company/CompanyStore')
const BillableFields = require('admin/data/company/fields/billable').default

// clone default company fields and concat more for the distributor record
const fields = BillableFields.concat([
  {
    name: 'defaultURI',
    type: 'string'
  },
  {
    name: 'companyRelationships'
  },
  {
    name: 'vendorName',
    type: 'string',
    mapping: 'companyRelationships',
    convert(input) {
      return CompanyStore.extractParentName(input, 'DISTRIBUTOR')
    }
  },
  {
    name: 'parentName'
  },
  {
    name: 'partyBillings[0].defaultCurrency',
    type: 'string',
    mapping: 'partyBillings[0].defaultCurrency.code'
  }
])

const DistributorRecord = Record.define(null, {
  extend: BillableRecord,
  fields,

  module() {
    return require('admin/business/DistributorResource')
  },

  getCurrency() {
    return this.get('partyBillings[0].defaultCurrency') || this.callParent()
  },

  isDistributor() {
    return true
  }
})

module.exports = DistributorRecord
